import React from 'react';
import { useNavigate } from 'react-router-dom';
import CareerHeaderButton from './CareerHeaderButton';
import {
  useAuth,
  useLoginRequiredModal,
  useIsMobile,
  useT,
} from '@repo/common';

const CareerHeader = () => {
  const t = useT();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { showLoginModal } = useLoginRequiredModal();
  const isMobile = useIsMobile();

  const handleCreateResume = () => {
    if (!isLoggedIn) {
      showLoginModal('career_cta');
      return;
    }
    navigate('/career/resumes/new?source=career_page_cta');
  };

  const handleManageResume = () => {
    if (!isLoggedIn) {
      showLoginModal('career_cta');
      return;
    }
    navigate('/mypage/resumes/all');
  };

  return (
    <div className='w-full flex justify-center bg-grayscale-gray01 p-4 tabletH:p-20'>
      <div className='flex flex-col tabletH:items-center justify-center w-full border-none'>
        <div className='flex flex-col justify-center tabletH:items-center gap-2 pb-4 tabletH:pb-[30px]'>
          <div className='hidden tabletH:flex flex-col justify-center tabletH:items-center'>
            <div className='flex'>
              <div className='typo-title1 tabletH:typo-h5 text-text-primary'>
                {t('Korean-Style', '한국형')}&nbsp;
              </div>
              <div
                className={`
                ${
                  isMobile
                    ? 'typo-title1'
                    : 'typo-h5 bg-[linear-gradient(transparent,transparent_60%,rgba(0,158,79,0.4)_60%)] inline-block tracking-wide'
                }
                  text-text-primary
              `}
              >
                {t('Resume', '이력서')}
              </div>
            </div>

            <div className='typo-title1 tabletH:typo-h5 text-text-primary'>
              {t('Done Right with Koready', 'Koready로 제대로 완성하세요')}
            </div>
          </div>

          <div className='typo-b12 tabletH:typo-b14 text-text-placeholder flex flex-wrap items-center justify-center text-center max-w-[868px] w-full'>
            <span>
              {t('No Korean? No problem.', '한국어를 못해도 괜찮아요.')}
            </span>
            <span className='basis-full tabletH:basis-auto tabletH:before:content-["\00a0"]'>
              {t(
                'We auto-translate into Korean.',
                '자동으로 한국어로 번역해 드려요.',
              )}
            </span>
          </div>
        </div>

        <div className='flex flex-col items-center justify-center gap-3 max-w-[868px] w-full'>
          <>
            <CareerHeaderButton type='create' onClick={handleCreateResume} />
          </>
          <div className='flex gap-2 w-full'>
            <CareerHeaderButton
              type='guide'
              text={t('Resume Guide', '이력서 가이드')}
              onClick={() => navigate('/career/resumes/guide')}
            />
            <CareerHeaderButton
              type='manage'
              text={t('Manage Resume', '이력서 관리')}
              onClick={handleManageResume}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerHeader;
